import callApi from '&/utils/callApi';
import * as types from '../constants/types';

const API = '/auth';

export const login = user => async dispatch => {
	const data = await callApi.post(`${API}/login`, user);

	if (data.user) {
		localStorage.setItem('token', data.token);

		dispatch({
			type: types.auth.LOGIN,
			payload: {
				user: data.user,
				token: data.token,
			},
		});
	}

	return data;
};

export const register = user => async dispatch => {
	const data = await callApi.post(`${API}/register`, user);

	if (data.user) {
		localStorage.setItem('token', data.token);

		dispatch({
			type: types.auth.REGISTER,
			payload: {
				user: data.user,
				token: data.token,
			},
		});
	}

	return data;
};
export const addKeypad = user => async dispatch => {
	const data = await callApi.post('/keypad/', user);

	console.log(data);

	return data;
};
export const addNewUser = user => async dispatch => {
	const data = await callApi.post(`${API}/register`, user);

	// if (data.user) {
	// 	localStorage.setItem('token', data.token);

	// 	dispatch({
	// 		type: types.auth.REGISTER,
	// 		payload: {
	// 			user: data.user,
	// 			token: data.token,
	// 		},
	// 	});
	// }

	return data;
};

export const logout = () => async dispatch => {
	const token = localStorage.getItem('token');

	if (token) {
		await callApi.get(`${API}/logout/${token}`);

		localStorage.removeItem('token');
	}

	dispatch({
		type: types.auth.LOGOUT,
	});
};

export const verify = () => async dispatch => {
	const token = localStorage.getItem('token');

	if (token) {
		const data = await callApi.get(`${API}/verify/${token}`);

		if (data.success) {
			dispatch({
				type: types.auth.LOGIN,
				payload: {
					user: data.user,
				},
			});
		} else {
			dispatch(logout());
		}
	} else {
		dispatch(logout());
	}
};
